import { useState } from 'react';
import './ExpandableTags.css';

interface tagDto {
    text: string,
    style?: React.CSSProperties 
}

interface ExpandableTagsProps {
  tags: tagDto[];
}

export default function ExpandableTags ({tags = []}: ExpandableTagsProps) {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  if (!tags || tags.length === 0) {
    return null;
  }

  const remainingTagsCount: number = tags.length - 1;

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className='expandable-tags-container'>
      <div className='main-tag-container'
        style={{
          cursor: remainingTagsCount > 0 ? "pointer" : "default",
        }}
        onClick={remainingTagsCount > 0 ? toggleExpand : undefined}
      >
        <TagBadge style={tags[0].style}>
          {tags[0].text}
        </TagBadge>

        {remainingTagsCount > 0 && (
          <TagBadge>
            + {remainingTagsCount} 
            {isExpanded ? 
                <i className="bi bi-chevron-up" style={{marginLeft: '4px'}}></i> : 
                <i className="bi bi-chevron-down" style={{marginLeft: '4px'}}></i>
            }
          </TagBadge>
        )}
      </div>
      {remainingTagsCount > 0 && isExpanded && (
        tags.slice(1).map((tag, i) => (
          <TagBadge key={i} style={{ marginTop: "5px", width: "fit-content", ...tag.style }}>
            {tag.text}
          </TagBadge>
        ))
      )}
    </div>
  );
};

interface TagBadgeProps {
    style?: React.CSSProperties;
    children: React.ReactNode;
}

function TagBadge ({ children, style = {} }: TagBadgeProps) {
    return (
        <div className='tag-badge-container' style={style}>
            {children}
        </div>
    )
};